import * as Yup from "yup";

export const YUPValidations = Yup.object().shape({
  centrePackageName: Yup.string()
    // .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  fromDate: Yup.date().nullable().required("Please select from date"),
  toDate: Yup.date()
    .nullable()
    .required("Please select to date")
    .min(Yup.ref("fromDate"), "To Date must be equal to or after from date")
    .min(
      new Date(new Date().setDate(new Date().getDate() - 1)),
      "To date must be today or later"
    )
    .test(
      "is-after-from",
      "To date must be greater than from date",
      function (value) {
        const fromDate = this.resolve(Yup.ref("fromDate"));
        return !fromDate || new Date(value) > new Date(fromDate);
      }
    ),
  centrePackageCode: Yup.string()
    // .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  agreedRate: Yup.number()
    .test(
      "is-less-than-mrp",
      "DC Rate must be less than or equal to DC MRP",
      (value, context) => {
        const mrp = context.parent.mrp;
        return value <= mrp;
      }
    )
    .when("walkInPrice", {
      is: (walkInPrice) =>
        walkInPrice !== null && walkInPrice !== "" && walkInPrice !== undefined,
      then: Yup.number()
        .nullable()
        .test(
          "is-less-than-walkInPrice",
          "DC Rate must be less than or equal to DC WalkInPrice",
          (value, context) => {
            const walkInPrice = context.parent.walkInPrice;
            return value <= walkInPrice;
          }
        ),
    })
    .test("decimal-places", "Only 2 decimal places are allowed", (value) => {
      if (value !== undefined && value !== null) {
        const decimalCount = (value.toString().split(".")[1] || "").length;
        return decimalCount <= 2;
      }
      return true;
    })
    .typeError("The field should have digits only")
    .moreThan(0, "DC Rate  should be greater than zero")
    .required("Field is required"),
  mrp: Yup.number()
    .typeError("The field should have digits only")
    .moreThan(0, "DC MRP should be greater than zero")
    .test("decimal-places", "Only 2 decimal places are allowed", (value) => {
      if (value !== undefined && value !== null) {
        const decimalCount = (value.toString().split(".")[1] || "").length;
        return decimalCount <= 2;
      }
      return true;
    })
    .required("Field is required"),
  walkInPrice: Yup.number()
    .max(Yup.ref("mrp"), "DC WalkInPrice must be less than or equal to DC MRP")
    .nullable()
    .test("decimal-places", "Only 2 decimal places are allowed", (value) => {
      if (value !== undefined && value !== null) {
        const decimalCount = (value.toString().split(".")[1] || "").length;
        return decimalCount <= 2;
      }
      return true;
    })
    .typeError("The field should have digits only"),
  // .moreThan(0, "DC WalkInPrice should be greater than zero"),
  // .required("Field is required"),
  gender: Yup.string(/^[A-Za-z ]*$/).nullable(),
  // .required("Field is required"),
  fastingRequired: Yup.string(/^[A-Za-z ]*$/).nullable(),
  // .required("Field is required"),
  visitType: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  // defaultMargin: Yup.number()
  //   .nullable()
  //   .typeError("The field should have digits only")
  //   .moreThan(0, "Default Margin should be greater than zero"),
  // minimumAge: Yup.number()
  //   .nullable()
  //   .max(Yup.ref("maxAge"))
  //   .typeError("The field should have digits only")
  //   .integer("Input must be a whole number")
  //   .moreThan(0, "Minimum Age should be greater than zero"),
  // maxAge: Yup.number()
  //   .nullable()
  //   .typeError("The field should have digits only")
  //   .integer("Input must be a whole number")
  //   .moreThan(0, "Max Age should be greater than zero"),
  // minRefRangeMale: Yup.number()
  //   .nullable()
  //   .max(Yup.ref("maxRefRangeMale"))
  //   .typeError("The field should have digits only")
  //   .moreThan(0, "Max Age should be greater than zero"),
  // maxRefRangeMale: Yup.number()
  //   .nullable()
  //   .typeError("The field should have digits only")
  //   .moreThan(0, "Max Age should be greater than zero"),
  // idealValueMale: Yup.number()
  //   .nullable()
  //   .typeError("The field should have digits only")
  //   .moreThan(0, "Max Age should be greater than zero"),
  // minRefRangeFemale: Yup.number()
  //   .nullable()
  //   .max(Yup.ref("maxRefRangeFemale"))
  //   .typeError("The field should have digits only")
  //   .moreThan(0, "Max Age should be greater than zero"),
  // maxRefRangeFemale: Yup.number()
  //   .nullable()
  //   .typeError("The field should have digits only")
  //   .moreThan(0, "Max Age should be greater than zero"),
  // idealValueFemale: Yup.number()
  //   .nullable()
  //   .typeError("The field should have digits only")
  //   .moreThan(0, "Max Age should be greater than zero"),
});

export const initialFilterState = {
  page: 1,
  rows: 10,
  facilityId: 0,
  sortDirection: "DESC",
  RequestStatus: null,
  providerId: 0,
};

export const initialHeaderTest = [
  "HA Package Code",
  "HA Package Name",
  "Provider Name",
  "DC Rate",
];

export const TestExcelHeaderColmns = {
  "HA Package Code": "facilityId",
  "HA Package Name": "facilityName",
  "Provider Name": "providerName",
  "DC Walk In Price": "customerOfferPrice",
  "DC Rate": "agreedRate",
  "DC MRP (Rs.)": "mrp",
  "Visit Type": "visitType",
  "Centre Package Code": "centrePackageCode",
  "Centre Package Name": "centrePackageName",
  Gender: "gender",
  "Fasting Required": "fastingRequired",
  "App Price": "appPrice1Graded",
};

export const TestExcelHeader = [
  { label: "HA Package Code", key: "facilityId" },
  { label: "HA Package Name", key: "facilityName" },
  { label: "Provider Name", key: "providerName" },
  { label: "DC Walk In Price", key: "customerOfferPrice" },
  { label: "DC MRP (Rs.)", key: "mrp" },
  { label: "DC Rate", key: "agreedRate" },
  { label: "Visit Type", key: "visitType" },
  { label: "Centre Package Code", key: "centrePackageCode" },
  { label: "Centre Package Name", key: "centrePackageName" },
  { label: "Gender", key: "gender" },
  { label: "Fasting Required", key: "fastingRequired" },
  { label: "App Price", key: "appPrice1Graded" },
  { label: "From Date", key: "fromDate" },
  { label: "To Date", key: "toDate" },
  { label: "ActiveOrInActive", key: "isActiveOrInActive" },
  { label: "ClientName", key: "ClientName" },
  // { label: "Sub Category", key: "subCategory" },
  // { label: "Default Margin", key: "defaultMargin" },
  // { label: "Display Facility Name", key: "displayFacilityName" },
  // { label: "Prepration For Checkup", key: "preprationForCheckup" },
  // { label: "SKU Synonyms", key: "skuSynonyms" },
  // { label: "SKU Long Description", key: "skuLongDescription" },
  // { label: "SKU Serach Tag", key: "skuSerachTag" },
  // { label: "Minimum Age", key: "minimumAge" },
  // { label: "Max Age", key: "maxAge" },
  // { label: "Final Reporting", key: "finalReporting" },
  // { label: "Sample Type", key: "sampleType" },
  // { label: "Min Ref Range Male", key: "minRefRangeMale" },
  // { label: "Max Ref Range Male", key: "maxRefRangeMale" },
  // { label: "Ideal Value Male", key: "idealValueMale" },
  // { label: "Units Male", key: "unitsMale" },
  // { label: "Min Ref Range Female", key: "minRefRangeFemale" },
  // { label: "Max Ref Range Female", key: "maxRefRangeFemale" },
  // { label: "Ideal Value Female", key: "idealValueFemale" },
  // { label: "Units Female", key: "unitsFemale" },
  // { label: "IsFrequently Used SKU", key: "isFrequentlyUsedSKU" },
];
export const CSVData = (getTestPackagesExcelDetail) =>
  getTestPackagesExcelDetail?.map((ele) => {
    return {
      facilityId: ele?.facilityId,
      providerName: ele?.providerName,
      centrePackageName: ele?.centrePackageName,
      centrePackageCode: ele?.centrePackageCode,
      facilityName: ele?.facilityName,
      agreedRate: ele?.agreedRate,
      customerOfferPrice: ele?.customerOfferPrice,
      mrp: ele?.mrp,
      gender:
        ele?.gender === "M" ? "Male" : ele?.gender === "F" ? "Female" : "Both",
      fastingRequired: ele?.fastingRequired === true ? "Yes" : "No",
      visitType:
        ele?.visitType === "HV"
          ? "Home Visit"
          : ele?.visitType === "DC"
          ? "Centre Visit"
          : ele?.visitType === "MIX"
          ? "Mix Visit"
          : "-",
      appPrice1Graded: ele?.appPrice1Graded,
      fromDate:
        new Date(ele?.fromDate).toLocaleDateString("en-GB") +
        " " +
        new Date(ele?.fromDate).toLocaleTimeString("en-GB"),
      toDate:  new Date(ele?.toDate).toLocaleDateString("en-GB") +
      " " +
      new Date(ele?.toDate).toLocaleTimeString("en-GB"),
      isActiveOrInActive: ele?.isActiveOrInActive,
      ClientName: ele?.clientName,

      // subCategory: ele?.subCategory,
      // defaultMargin: ele?.defaultMargin,
      // displayFacilityName: ele?.displayFacilityName,
      // preprationForCheckup: ele?.preprationForCheckup,
      // skuSynonyms: ele?.skuSynonyms,
      // skuLongDescription: ele?.skuLongDescription,
      // skuSerachTag: ele?.skuSerachTag,
      // minimumAge: ele?.minimumAge,
      // maxAge: ele?.maxAge,
      // finalReporting: ele?.finalReporting,
      // sampleType: ele?.sampleType,
      // minRefRangeMale: ele?.minRefRangeMale,
      // maxRefRangeMale: ele?.maxRefRangeMale,
      // idealValueMale: ele?.idealValueMale,
      // unitsMale: ele?.unitsMale,
      // minRefRangeFemale: ele?.minRefRangeFemale,
      // maxRefRangeFemale: ele?.maxRefRangeFemale,
      // idealValueFemale: ele?.idealValueFemale,
      // unitsFemale: ele?.unitsFemale,
      // isFrequentlyUsedSKU: ele?.isFrequentlyUsedSKU,
    };
  });
